import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { withT } from '../../lib/wrappers';

const Help = ({ popoverProps, helpText, faIcon, t }) => (
  <OverlayTrigger
    trigger="click"
    placement="left"
    overlay={(
      <Popover
        className="calculator__popover"
        {...popoverProps}
      >
        <div dangerouslySetInnerHTML={{ __html: helpText }} />
      </Popover>
    )}
  >
    <button
      className="btn btn-xs btn-default help-icon"
    >
      <i className={`fa fa-${faIcon}`} />
      <span style={{ display: 'none' }}>{t('help')}</span>
    </button>
  </OverlayTrigger>
);

Help.propTypes = {
  popoverProps: PropTypes.shape({}),
  helpText: PropTypes.string.isRequired,
  faIcon: PropTypes.string,
  t: PropTypes.func.isRequired,
};

Help.defaultProps = {
  faIcon: 'question-circle',
  popoverProps: {},
};

export default withT('common')(Help);

